import PublicNavbar from 'components/PublicNavbar';
import PublicHero from 'components/PublicHero';
import React from 'react';

const Home = () => {
	return (
		<div>
			<PublicNavbar />
			<PublicHero />
		</div>
	);
};

export default Home;
